import React from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import { useState } from 'react'
import { useEffect } from 'react'
import { getDateAndTimeText } from '../../../../../helpers/date/dateHelper'
import ChangeStatusWriteOffActButton from '../../../forms/changeStatus/ChangeStatusWriteOffActButton'
import WriteOffActDownload from '../../actions/downloadAct/WriteOffActDownload'
import WriteOffActDownloadButton from '../../actions/downloadAct/WriteOffActDownloadButton'
import ChangeNumberBasButton from '../../forms/changeNumberBas/ChangeNumberBasButton'

const WriteOffActAbout = ({ writeOffAct }) => {

    const [list, setList] = useState([])

    useEffect(() => {
        setListItems()
    }, [writeOffAct])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Номер',
            value: writeOffAct ? writeOffAct.id : '-'
        })
        listTemp.push({
            name: 'Номер з БАС',
            value: 
                <ChangeNumberBasButton 
                    writeOffAct={writeOffAct}
                />
        })
        listTemp.push({
            name: 'Статус',
            value:
                <ChangeStatusWriteOffActButton 
                    writeOffAct={writeOffAct} 
                />
        })
        listTemp.push({
            name: 'Дата створення',
            value: writeOffAct ? getDateAndTimeText(writeOffAct.createdAt) : '-'
        })
        listTemp.push({
            name: 'Опис',
            value: writeOffAct ? writeOffAct.description : '-'
        })
        listTemp.push({
            name: 'Дії',
            value: 
                <WriteOffActDownloadButton 
                    writeOffActId={writeOffAct.id}
                />
        })

        setList(listTemp)
    }

  return (
    <MyListBlock
        className={'supplyOrderView__topBlock'}
        text={'Про заявку'}
        list={list}
    />
  )
}

export default WriteOffActAbout